import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerNarrowTwoColumnsConverter extends CmsConverterService<CongressContainerNarrowTwoColumnsData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      left: formData.st_left_content ?? defaultFSCatalog,
      right: formData.st_right_content ?? defaultFSCatalog
    }
  }
}

export const CONGRESS_CONTAINER_NARROW_TWO_COLUMNS_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerNarrowTwoColumnsData>>('CongressContainerNarrowTwoColumnsConverter')

export interface CongressContainerNarrowTwoColumnsData extends ConvertedComponentData {
  left: FsCatalog;
  right: FsCatalog;
}
